// @flow
import { get, slice } from "lodash";
import type { OperationComponent } from "@apollo/client";
import type { Props } from "../types";

const formatPastRaces = (pastRaces) => {
  const array = [null, null, null, null];

  const newArray = pastRaces.concat(array);

  return slice(newArray, 0, 4);
};

export default {
  options: (props: Props) => {
    const runner = get(props, "runner.runners").find(
      (runnerItem) => runnerItem.runnerId === get(props, "runnerId")
    );

    const variables = {
      wagerProfile: get(props, "wagerProfile", "FDR-Generic"),
      entityRunnerId: get(runner, "entityRunnerId", "")
    };

    return {
      client: get(props, "fcpClient", null),
      fetchPolicy: "no-cache",
      ssr: false,
      variables
    };
  },
  props: (result: OperationComponent<Response>) => ({
    runnerStats: get(result, "data.runnerStats"),
    pastRaces: get(result, "data.pastRaces")
      ? formatPastRaces(slice(get(result, "data.pastRaces"), 0, 4))
      : null,
    numberOfRaces: get(result, "data.pastRaces.length", 0),
    isLoading: result.data.loading,
    subscribeToMore: result.data.loading ? null : result.data.subscribeToMore,
    refetch: result.data.refetch
  })
};
